import { render, staticRenderFns } from "./detailFile.vue?vue&type=template&id=6fc74270&scoped=true&"
import script from "./detailFile.vue?vue&type=script&lang=js&"
export * from "./detailFile.vue?vue&type=script&lang=js&"
import style0 from "./detailFile.vue?vue&type=style&index=0&id=6fc74270&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc74270",
  null
  
)

export default component.exports